import { changepassportdetails } from '../Actions/ActionTypes';

const initialState = {
    passportDetails: {
        application: false,
    },
}

const PassportDetailsReducer = (state = initialState, action) => {
    switch(action.type){
        case changepassportdetails: 
            return ({
                ...state,
                passportDetails: action.passportDetails
            })
        default :
            return state
    }

}

export default PassportDetailsReducer;